import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mtm-save-model-confirmation-modal',
  templateUrl: './save-model-confirmation-modal.component.html',
  styleUrl: './save-model-confirmation-modal.component.scss',
  standalone: false,
})
export class SaveModelConfirmationModalComponent {
  @Input() workspaceName: string = '';
  @Input() modelName: string = 'modal';
  @Output() confirmSave = new EventEmitter<void>();

  constructor(private readonly activeModal: NgbActiveModal) {}

  onCancel() {
    this.activeModal.dismiss();
  }

  onConfirmSave() {
    this.confirmSave.emit();
    this.activeModal.close();
  }
}
